import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-leave-overview-bottomsheet',
    templateUrl: './leave-overview-bottomsheet.component.html',
    styleUrls: ['./leave-overview-bottomsheet.component.scss']
})
export class LeaveOverviewBottomsheetComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any>;

    constructor(
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
    ) {
      this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        console.log(this.data);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }
}
